// frontend/src/pages/Manager/Updates/UpdateMaterial.jsx
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { FaSave, FaTimesCircle } from 'react-icons/fa';
import './UpdateMaterial.css';
import ManagerSidebar from '../../../components/Sidebar/ManagerSidebar';

const UpdateMaterial = () => {
  const { id } = useParams(); // Get material ID from URL
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    material_name: '',
    category: '',
    quantity: '',
    material_condition: '',
    brand: '',
    material_type: '',
    purchase_date: '',
    remarks: '',
    image_url: ''
  });

  useEffect(() => {
    if (id) fetchMaterial();
  }, [id]);

  const fetchMaterial = async () => {
    try {
      const response = await axios.get(`https://ikaze-thouse-backend.vercel.app/api/v1/materials/get/${id}`);
      if (response.data.success) {
        setFormData(response.data.data);
      } else {
        alert('Failed to fetch material details');
      }
    } catch (err) {
      console.error(err);
      alert('Error fetching material');
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleUpdate = async () => {
    try {
      await axios.put(`https://ikaze-thouse-backend.vercel.app/api/v1/materials/update/${id}`, formData);
      alert('Material updated successfully!');
      navigate('/manager/MaterialsManagement');
    } catch (err) {
      console.error(err);
      alert('Failed to update material');
    }
  };

  return (
    <div className="update-material-page">
      <div className="side">
        <ManagerSidebar />
      </div>

      <div className="update-material-content">
        <h2>Edit Material</h2>

        <div className="update-form">
          <div className="form-grid">
            <input
              name="material_name"
              placeholder="Material Name"
              value={formData.material_name}
              onChange={handleChange}
            />
            <input
              name="category"
              placeholder="Category"
              value={formData.category}
              onChange={handleChange}
            />
            <input
              name="quantity"
              placeholder="Quantity"
              value={formData.quantity}
              onChange={handleChange}
            />
            <input
              name="material_condition"
              placeholder="Condition"
              value={formData.material_condition}
              onChange={handleChange}
            />
            <input
              name="brand"
              placeholder="Brand"
              value={formData.brand}
              onChange={handleChange}
            />
            <input
              name="material_type"
              placeholder="Type"
              value={formData.material_type}
              onChange={handleChange}
            />
            <input
              name="purchase_date"
              type="date"
              value={formData.purchase_date}
              onChange={handleChange}
            />
            <input
              name="remarks"
              placeholder="Remarks"
              value={formData.remarks}
              onChange={handleChange}
            />
            {/* <input
              name="image_url"
              placeholder="Image URL"
              value={formData.image_url}
              onChange={handleChange}
            /> */}
          </div>

          <div className="update-actions">
            <button className="btn-save" onClick={handleUpdate}>
              <FaSave /> Save
            </button>
            <button
              className="btn-cancel"
              onClick={() => navigate('/manager/MaterialsManagement')}
            >
              <FaTimesCircle /> Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateMaterial;
